import { render, staticRenderFns } from "./AppointmentWarningInfoTelemed.vue?vue&type=template&id=ca19849e&scoped=true&"
import script from "./AppointmentWarningInfoTelemed.vue?vue&type=script&lang=js&"
export * from "./AppointmentWarningInfoTelemed.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentWarningInfoTelemed.vue?vue&type=style&index=0&id=ca19849e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca19849e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca19849e')) {
      api.createRecord('ca19849e', component.options)
    } else {
      api.reload('ca19849e', component.options)
    }
    module.hot.accept("./AppointmentWarningInfoTelemed.vue?vue&type=template&id=ca19849e&scoped=true&", function () {
      api.rerender('ca19849e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentPage/components/common/AppointmentWarningInfoTelemed.vue"
export default component.exports